export default "__VITE_ASSET__B6rl7yw6__"